const mutations = {
    /**
   * [SET_LEAD_VALUE description]
   * @param {[type]} state  [description]
   * @param {[type]} answer [description]
   */
    SET_LEAD_VALUE(state, answer) {
        console.log('set lead', answer.value)
        answer.leadKey = answer.leadKey || answer.key
        state.lead[answer.leadKey] = answer.value
    },

    /**
   * [INCREMENT_SECTION_INDEX description]
   * @param {[type]} state [description]
   */
    INCREMENT_SECTION_INDEX(state) {
        state.currentSectionIndex++
    },

    /**
   * [DECREMENT_SECTION_INDEX description]
   * @param {[type]} state [description]
   */
    DECREMENT_SECTION_INDEX(state) {
        state.currentSectionIndex--
    },

    /**
   * [REMOVE_QUESTION_ERRORS description]
   * @param {[type]} state [description]
   */
    REMOVE_ERRORS(state, key) {
        delete state.errors[key]
    },

    /**
   * [SET_SECTION_INDEX description]
   * @param {[type]} state [description]
   * @param {[type]} index [description]
   */
    SET_SECTION_INDEX(state, index) {
        state.currentSectionIndex = index
    },

    /**
   * [SET_QUESTIONS description]
   * @param {[type]} state     [description]
   * @param {[type]} questions [description]
   */
    SET_QUESTIONS(state, questions) {
        state.questions = questions
    },

    /**
   * [ADD_REQUIRED_ERROR description]
   * @param {[type]} state [description]
   * @param {[type]} key   [description]
   */
    ADD_REQUIRED_ERROR(state, key) {
        let error = {}
        error[key] = ['This field is required']
        state.errors = { ...state.errors, ...error }
    },

    /**
   * [ADD_ERRORS description]
   * @param {[type]} state  [description]
   * @param {[type]} errors [description]
   */
    ADD_ERRORS(state, errors) {
        state.errors = { ...state.errors, ...errors }
    },

    /**
   * [ADD_AREA_OF_CONCERN description]
   * @param {[type]} state [description]
   * @param {[type]} area  [description]
   */
    ADD_AREA_OF_CONCERN(state, area) {
        state.lead.areasOfConcern.push(area)
    },

    /**
   * [APPLY_LEAD_BINDINGS_FROM_STORAGE description]
   * @param {[type]} state [description]
   * @param {[type]} lead  [description]
   */
    APPLY_LEAD_BINDINGS_FROM_STORAGE(state, lead) {
        state.lead = { ...lead }
    },

    /**
   * [SET_ESSENTIAL_SYSTEM description]
   * @param {[type]} state     [description]
   * @param {[type]} essential [description]
   */
    SET_ESSENTIAL_SYSTEM(state, essential) {
        state.system.essential = essential
    },

    /**
   * [SET_PROTECTION_LEVEL_WARNINGS description]
   * @param {[type]} state    [description]
   * @param {[type]} warnings [description]
   */
    SET_PROTECTION_LEVEL_WARNINGS(state, warnings) {
        for (var i = 0; i < warnings.length; i++) {
            warnings[i] = {
                ...warnings[i],
                dismissed: false
            }
        }
        state.protectionLevelWarnings = warnings
    },

    /**
   * [DISMISS_PROTECTION_LEVEL_WARNING description]
   * @param {[type]} state [description]
   * @param {[type]} index [description]
   */
    DISMISS_PROTECTION_LEVEL_WARNING(state, index) {
        state.protectionLevelWarnings[index].dismissed = true
    },

    /**
   * [DISMISS_PROTECTION_LEVEL_WARNING description]
   * @param {[type]} state [description]
   * @param {[type]} index [description]
   */
    DISMISS_PROTECTION_LEVEL_WARNINGS(state) {
        for (var i = 0; i < state.protectionLevelWarnings.length; i++) {
            state.protectionLevelWarnings[i].dismissed = true
        }
    },

    /**
   * [TOGGLE_MODAL description]
   * @param {[type]} state [description]
   */
    TOGGLE_MODAL(state) {
        state.modalOpen = !state.modalOpen
    },

    /**
   * [UPDATE_AREA_OF_CONCERN description]
   * @param {[type]} state         [description]
   * @param {[type]} areaOfConcern [description]
   */
    UPDATE_AREA_OF_CONCERN(state, areaOfConcern) {
        state.areaOfConcern = Object.assign(
            {},
            state.areaOfConcern,
            areaOfConcern
        )
    },

    EXPAND_AREA_OF_CONCERN(state, index) {
        state.lead.areasOfConcern[index].expanded = true
    },

    CLOSE_AREA_OF_CONCERN(state, index) {
        state.lead.areasOfConcern[index].expanded = false
    },

    DELETE_AREA_OF_CONCERN(state, index) {
        state.lead.areasOfConcern.splice(index, 1)
    },

    SET_TRUE_ADVICE(state, trueAdvice) {
        state.adviceCount = trueAdvice.total_count
        state.system.additional = trueAdvice.additional
    },

    SET_SYSTEM_PRICE(state, total) {
        state.system.total = total
    },

    SET_HEADER_SHADOW(state, bool) {
        state.headerShadow = bool
    },

    UPDATE_AREAS_OF_CONCERN(state, areas) {
        state.lead.areasOfConcern = areas
    },

    EXPAND_GUARANTEE(state, index) {
        state.guarantees[index].expanded = true
    },

    CLOSE_GUARANTEE(state, index) {
        state.guarantees[index].expanded = false
    },

    UPDATE_SYSTEM(state, system) {
        state.system = { ...system }
    },

    TOGGLE_EQUIPMENT_EXPANDED(state, payload) {
        let index = payload.index
        let type = payload.type
        state['system'][type][index].expanded = !state['system'][type][index]
            .expanded
    },

    TOGGLE_HELP_EQUIPMENT_EXPANDED(state, index) {
        state.equipment[index].expanded = !state.equipment[index].expanded
    },

    UPDATE_AUTOMATION_INTERESTS(state, interests) {
        state.lead.automationInterests = interests
    },

    WANTS_MORE_AUTOMATION(state, theKey) {
        state.automationInterestsMore[theKey] = true
    },

    CANCEL_MORE_AUTOMATION(state, theKey) {
        state.automationInterestsMore[theKey] = false
    },

    SET_EQUIPMENT(state, equipment) {
        state.equipment = equipment
    },

    SET_MONITORING_PLANS(state, plans) {
        state.monitoringPlans = plans
    },

    UPDATE_NAME(state, name) {
        state.lead.name = name
    },

    UPDATE_EMAIL(state, email) {
        state.lead.email = email
    },

    SET_AREAS_OF_CONCERN(state, areas) {
        state.availableAreas = areas
    },

    TOGGLE_EDIT_HOME_VISIBILITY(state) {
        state.editHomeVisible = !state.editHomeVisible
    },

    SET_EQUIPMENT_QUANTITY(state, data) {
        let key = data.key
        let value = data.value
        state.lead.automationQuantities[key] = value
    },

    SET_EQUIPMENT_QUANTITIES(state, quantities) {
        state.lead.automationQuantities = quantities
    },

    SET_MONITORING_PLANS(state, plans) {
        state.system.monitoringPlans = plans
    },

    SET_ADDITIONAL_THREATS(state, threats) {
        state.lead.additionalThreats = threats
    },

    SET_MONITORING_PLAN_FREQUENCY(state, frequency) {
        state.system.monitoringPlanFrequency = frequency
    },

    TOGGLE_MONITORING_FREQUENCY_VISIBLE(state) {
        state.monitoringFrequencyVisible = !state.monitoringFrequencyVisible
    },

    SET_PAYMENT_METHOD(state, option) {
        state.system.paymentMethod = option
    },

    SET_PLACE(state, place) {
        state.lead.place = place
    },

    UPDATE_ORDER(state, order) {
        state.order = { ...order }
    },

    INCREMENT_AOC_SECTION_INDEX(state){
        state.areaOfConcernSectionIndex++
    },
    DECREMENT_AOC_SECTION_INDEX(state){
        state.areaOfConcernSectionIndex--
    },
    SET_AOC_SECTION_INDEX(state, index){
        state.areaOfConcernSectionIndex = index
    },

    SET_ENVIRONMENTAL_RECOMMENDATION_QUANTITY(state, data) {
        let key = data.key
        let value = data.value
        state.environmentalRecommendations[key] = value
    },

    TOGGLE_SLIDEOUT(state) {
        state.slideout.open = !state.slideout.open
    },

    CLOSE_SLIDEOUT(state) {
        state.slideout.open = false
    },
    
    toggleTalkWithGuideVisible(state) {
        state.talkWithGuideVisible = !state.talkWithGuideVisible
    },

    SET_BUSINESS_HOURS(state, data) {
        state.isBusinessHours = data
    }
}

export default mutations
